import type { IPermissionRepository } from '@src/domain/rbac/repository/permission_repository';
import type { Permission } from '@src/domain/rbac/entities/permission.entity';

/**
 * Get Permission By ID Use Case
 * Retrieves a specific permission by its ID
 */
export class GetPermissionByIdUseCase {
    constructor(private readonly permissionRepository: IPermissionRepository) { }

    async execute(permissionId: string): Promise<Permission | null> {
        return await this.permissionRepository.getById(permissionId);
    }
}
